module.exports = __webpack_public_path__ + "img/realisationFromagerie.f0f62f86.jpg";